module.exports = __webpack_public_path__ + "static/media/external-causes-of-morbidity-and-mortality-icon.7c4e7b07.svg";